module.exports = __webpack_public_path__ + "static/media/iphone-img-thc.3b995c02.svg";